var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c(_setup.TripHistory,{attrs:{"trip-type":"completed","request-function":(params) => _setup.fetchTrips(params),"show-actions":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }